const page = `

{settings}
document.title: Magnus Betnér
og.title: Magnus Betnér
og.image: http://quickshot.imgix.net/opinionsbildaren-magnus-betner/betner4.png?w=1000&auto=format
og.twitterImage: http://quickshot.imgix.net/opinionsbildaren-magnus-betner/betner4.png?h=120&w=120&auto=format&fit=crop
og.description: I nästan 20 år har Magnus Betnér roat och provocerat på Sveriges stå-upp scener. Alla är måltavlor, men med sin kyrkliga bakgrund driver han särskilt gärna med religion.
og.url: http://pejl.svt.se/opinionsbildaren-magnus-betner
siteCatalyst.name: opinionsbildaren-magnus-betner
siteCatalyst.category: lyxartikel
{}
[+page]
{.div}
  style.position:relative
  style.backgroundColor: black
  style.color:white
  style.height: 100%;
  style.marginBottom: -18px;
  [.+content]
  
  
    {.div}
      style.minHeight:70vh
      style.position:relative
      style.paddingBottom:25px
      [.+content]
        {.div}
          style.position:relative
          style.width: 300px
          style.height:45px
          style.top:20px
          style.backgroundImage: url('http://quickshot.imgix.net/annika-beijbom/ob-1-rad-vit-ht_720.png')
          style.backgroundPositionY: 50%
          style.backgroundPositionX: 0%
          style.backgroundSize: cover
          [.+content]
          []
        {}
        
        luft:-50
          rubrik3: Magnus Betnér
          
          {.video}
            id:12498399?autostart=true
            storlek:ltext
          {}

          citat:Jag har ju nåt slags uppdrag som jag har gett mig själv - att försöka göra världen bättre
               
      []
    {}
    
    
    
    {.div}
      style.minHeight:50vh
      style.backgroundColor: #111
      style.display:flex
      style.flexDirection:column
      style.justifyContent:center
      style.paddingBottom:25px
      [.+content]
        {.div}
          [.+content]
          
            mellanrubrik: KYRKAN
      
            I nästan 20 år har Magnus Betnér roat och provocerat på Sveriges stå upp-scener. Journalister, politiker, kändisar – allt och alla är måltavlor. Och med sin kyrkliga bakgrund driver han särskilt gärna med religion.  
            Pappa Lennarth var pastor i Missionskyrkan och Magnus upplevde allt som hörde den frireligiösa uppväxten till till – söndagsskola, barnkören, scouterna. Hemma gällde strikta regler. Inget kortspel, inget dansande. Kiss var djävulens musik och Kalle Anka var för våldsam. Böcker, däremot, var alltid tillåtna. Som ung vuxen gav Magnus tron en rejäl chans – för att sedan ge upp den helt och hållet.    

          []
        {}
      []
    {}
    
    
    
    
    
    {.div}
      style.minHeight:80vh
      style.position:relative
      style.paddingTop:20%
      [.+content]
           
        {.video}
          id:12498510
          storlek:ltext
        {}

        citat:Jag tror att vuxendopet liksom var dödsryckningen i ett försök att lappa ihop min relation till gud
      []
    {}
    
    
        
    
    {.div}
      style.minHeight:100vh
      style.backgroundImage: url('http://quickshot.imgix.net/opinionsbildaren-magnus-betner/betner1.png?h=1200&w=1200&fit=crop&auto=format&q=45&cs=tinysrgb')
      style.backgroundPositionY: 50%
      style.backgroundPositionX: 10%
      style.backgroundRepeat: no-repeat
      style.backgroundSize: cover
      [.+content]

      []
    {}
    
    
    
    {.div}
      style.minHeight:100vh
      style.backgroundColor: #111
      style.display:flex
      style.flexDirection:column
      style.justifyContent:center
      [.+content]
        {.div}
          [.+content]
          
            mellanrubrik: ARTISTEN
    
            Efter gymnasiet började Magnus studera till SO-lärare, men stod bara ut ett år och gick över till att studera till lärare i idrott och historia.
            Men det saknades humor på lärarhögskolan och ett extrajobb började ta mer tid i anspråk. Han hade börjat jobba på en jonglerings- och gatuuppträdandebutik och satsade samtidigt på en karriär som gatuartist. Han jonglerade med brinnande facklor, cyklade enhjuling och trollade. Men Sverige var inte redo för gatuartisteriet. Artisterna sågs som tiggare, berättar han, och ingen ville betala för gatuunderhållning.
            Magnus började mer och mer dras till stand up-scenen, som vid den tidpunkten inte var så stor i Sverige. 1998 gick han över till stand up på heltid.
            
          []
        {}
      []
    {}
    
    
    
    
    
    {.div}
      style.minHeight:85vh
      style.position:relative
      style.paddingTop:15%
      [.+content]
       
        {.video}
          id:12498486
          storlek:ltext
        {}

        citat:Det finns ingenting läskigare än att ställa sig på ett tomt torg, dra ihop en publik själv och göra en show som man kanske inte får betalt för
      []
    {}
    
    
    
    
    {.div}
      style.minHeight:100vh
      style.backgroundImage: url('http://quickshot.imgix.net/opinionsbildaren-magnus-betner/betner2.png?h=1200&w=1200&fp-x=0.1&fit=crop&auto=format&q=45&cs=tinysrgb')
      style.backgroundPositionY: 55%
      style.backgroundPositionX: 30%
      style.backgroundRepeat: no-repeat
      style.backgroundSize: cover
      [.+content]

      []
    {}
    
    
    
    {.div}
      style.minHeight:100vh
      style.backgroundColor: #111
      style.display:flex
      style.flexDirection:column
      style.justifyContent:center
      [.+content]
        {.div}
          [.+content]
          
            mellanrubrik: RÄDSLAN
    
            2004 tog hans komikerkarriär fart på allvar i och med TV4:s Parlamentet. Han blev utnämnd till Sveriges bästa manliga komiker vid Svenska stand up-galan både 2005 och 2010.
            Magnus och parhästen Soran Ismail är nu inne på sin andra turné ihop. En av anledningarna till att Magnus och Soran trivs ihop är att de har liknande åsikter. Men vad rädsla är – det kan de inte enas om. 
            I augusti 2015 kommenterade Magnus dubbelmordet på Ikea i en video på Youtube. Reaktionerna vällde in. Magnus blev kallad landsförrädare, folk klippte om hans video och korsklippte mot filmer med mord och våldtäkter. Näthatet antog enorma proportioner.

          []
        {}
      []
    {}
    
    
    
    {.div}
      style.minHeight:100vh
      style.position:relative
      style.paddingTop:20%
      [.+content]
       
        {.video}
          id:12639448
          storlek:ltext
        {}

        citat:Jag har tränat ganska länge på att bli utsatt för det här, men jag tyckte det var skitjobbigt, absolut
      []
    {}
    
    
    
    
    {.div}
      style.minHeight:100vh
      style.backgroundColor: #111
      style.display:flex
      style.flexDirection:column
      style.justifyContent:center
      [.+content]
        {.div}
          [.+content]
            mellanrubrik:FÖRORTEN
            När man frågar människor som känner honom vem Magnus Betnér egentligen är, får man svaren ”orädd, asocial, gillar inte att prata i telefon, oerhört intelligent”. Han beskrivs ofta som arg och deppig, men ser sig själv som ganska glad.
            Han trivs i Stockholmsförorten Vällingby, som ibland beskrivs som en idyll, ibland som en no go-zon.
            Centrala Stockholm lockar inte längre.
          []
        {}
      []
    {}
    

    
    {.div}
      style.minHeight:80vh
      style.position:relative
      style.paddingTop:20%
      [.+content]
       
        {.video}
          id:12498540
          storlek:ltext
        {}

        citat:Det händer mer skit runt Stureplan än vad det gör i vilken förort som helst
      []
    {}
    
    
    
    {.div}
      style.minHeight:100vh
      style.position:relative
      style.paddingTop:10%
      [.+content]
       
      
      
      {.div}
        style.backgroundColor: #eee
        style.color:#111
        style.maxWidth: 600px
        style.padding: 1px 12px
        style.margin: 0 auto
        [.+content]
           mellanrubrik: OM MAGNUS
           
          {.bild}
            fil:opinionsbildaren-magnus-betner/betner4.png
            storlek:m
          {}
          
          [Född:] I augusti 1974 i Stockholm.
          
          [Familj:] Dotter Lina och fästmö Helena Sandklef.
          
          [Bor:] I Vällingby.
          
          [Aktuell:] Med turnén ”En skam för Sverige 2” tillsammans med Soran Ismail.
          
          [Yrkesliv:] Har arbetat sen slutet av 90-talet. Gjort flera slutsålda Sverige-turnéer. Medverkat i ett flertal tv-produktioner, bland andra Parlamentet, Betnér direkt, Debatt, Extra! Extra! och Stockholm Live.
          
          [På fritiden:] Köper saker på Tradera. Läser böcker. Dricker whiskey och öl. Spelar poker. Umgås med familjen.
          
          [Favoritbok:] Fear and Loathing on the Campaign Trail \`72 av Hunter S. Thompson.
          
          [Favoritingrediens i mat:] Habanero. Annars blir det mycket halvfabrikat och fuskmat.
          
          [Favoritdoft:] När grannarna i trapphuset lagar mat. Det luktar hemtrevligt.
          
          [Samlar på:] Förr: frimärken. Nu: Böcker och serietidningar. Har en myntsamling. Samlar även på sig ”massa skit från Tradera”. Senaste inköpet var tyska vykort från andra världskriget med Hitler på. Varför Hitler? Hehe, det har jag nog tyvärr inget bra svar på. Ibland blir det en porslinskatt, ibland blir det Rosseaus memoarer. Den här gången blev det Hitler.
          
          [Om du skulle ge ett råd till ditt 20-åriga jag:] Ta det lugnt. Du hinner få jobb och du hinner bli av med det. Du hinner bli full och förlora oskulden. Du behöver inte stressa.
          
          [Berätta något som ingen vet om dig:] En gång så tog jag en springnota på Pizza Hut för att se om det gick. Jag var 15.
          
          [Vad ska det stå på din gravsten:] Spelar ingen roll, det räcker med namnet. Jag är ändå död. Fattar inte varför folk ska hålla på och bygga monument.
          
          luft:
        []
      {}
      

       
      []
    {}
    
    
    luft:200
    
    rubrik5:Reporter: Valeria Helander
    rubrik5:Fotograf: Åke Wehrling
    rubrik5:[SVT Opinion | http://www.svt.se/opinion/12516028 | white | target:_self  ]
    
    {.sharebuttons}
    title: Magnus Betnér
    url: http://pejl.svt.se/opinionsbildaren-magnus-betner
    {}
       
    luft:100
   
  []
{}



[]
`;

export default page;

/*

 {.div}
 style.minHeight:100vh
 style.paddingTop:20%
 [.+content]

 []
 {}

 */



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/articles/opinionsbildaren-magnus-betner.js
 **/